import PitchAndPanelContainer from './pitch_and_panel_container';

const PitchAndPanel = PitchAndPanelContainer;
export default PitchAndPanel;
